// eslint-disable-next-line no-restricted-imports
import { ThemeOptions } from '@mui/material';

const shape: ThemeOptions['shape'] = {
  borderRadius: 10,
};

export default shape;
